import { type ReactNode } from 'react';
import {
  type ProductDetail,
  type GetProductV2Params as GetProductParams,
} from '@hungryroot/rest';
import {
  useNextOrderV3,
  useOrderDateParam,
  useProduct,
} from '@hungryroot/rest-hooks';

interface ProductLoaderChildProps {
  product?: ProductDetail;
  isError?: boolean;
}

interface ProductLoaderProps {
  id: number;
  initialData?: ProductDetail;
  children: (props: ProductLoaderChildProps) => ReactNode;
}

export function ProductLoader(props: ProductLoaderProps) {
  const { id, initialData, children } = props;
  const params: GetProductParams = {
    productId: id,
  };
  const { order } = useNextOrderV3();
  const orderDate = useOrderDateParam(order);
  if (orderDate) {
    params.orderDate = orderDate;
  }

  if (order?.origin) {
    params['origin'] = order.origin;
  }

  const { data: product, isError } = useProduct(params, {
    enabled: !!id,
    initialData,
  });

  return children({ product, isError });
}
